import { useId } from 'react'
import { TagChipContent } from './tagChipContent'
import { findSuggestedTag, normalizeTagSuggestions } from './tagSuggestions'
import styles from './SuggestedTagChips.module.css'

// AI tag suggestions as chips beside the control that asked for them. A chip
// that names a saved tag toggles it; one that names no saved tag stays visible
// but disabled, so the operator sees what the model proposed.
export default function SuggestedTagChips({
  suggestions = [],
  tags = [],
  selectedTagIds = [],
  onToggleTag,
  pending = false,
  title = 'Suggested tags',
  emptyMessage = '',
  actions = null,
}) {
  const headingId = useId()
  const normalizedSuggestions = normalizeTagSuggestions(suggestions)

  return (
    <section className={styles.group} aria-labelledby={headingId}>
      <div className={styles.header}>
        <span id={headingId} className={styles.label}>{title}</span>
        {pending ? <span className={styles.status} role="status">Finding tags…</span> : null}
      </div>
      {normalizedSuggestions.length > 0 ? (
        <div className={styles.list}>
          {normalizedSuggestions.map((suggestion) => {
            const match = findSuggestedTag(tags, suggestion)
            const selected = Boolean(match && selectedTagIds.includes(match.id))
            return (
              <button
                key={suggestion}
                type="button"
                className={`${styles.chip} ${selected ? styles.selected : ''}`}
                disabled={!match}
                aria-pressed={match ? selected : undefined}
                title={match ? `${selected ? 'Remove' : 'Add'} ${match.label}` : 'No saved tag matches this suggestion'}
                onClick={() => {
                  if (match) onToggleTag?.(match.id)
                }}
              >
                <TagChipContent tag={match} fallbackLabel={suggestion} />
              </button>
            )
          })}
        </div>
      ) : emptyMessage ? (
        <p className={styles.empty}>{emptyMessage}</p>
      ) : null}
      {actions && normalizedSuggestions.length > 0 ? <div className={styles.actions}>{actions}</div> : null}
    </section>
  )
}
